import script from "./accountList.vue?vue&type=script&lang=ts&setup=true"
export * from "./accountList.vue?vue&type=script&lang=ts&setup=true"

import "./accountList.vue?vue&type=style&index=0&id=4745f358&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4745f358"]])

export default __exports__